'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.useSessionStorage = exports.useLocalStorage = void 0;
const react_1 = require('react');
function getItem(storage, key) {
  const value = storage.getItem(key);
  return value ? JSON.parse(value) : null;
}
function setItem(storage, key, value) {
  storage.setItem(key, JSON.stringify(value));
}
function createMemoryStorage() {
  const storage = {};
  return {
    getItem(key) {
      return storage[key] || null;
    },
    setItem(key, value) {
      storage[key] = value;
    },
  };
}
function getStorage(name) {
  return typeof window === 'object' && window[name]
    ? window[name]
    : createMemoryStorage();
}
/**
 * A wrapper for useState that retrieves the initial state from a
 * WebStorage object and saves the state there as it changes.
 */
function useStorage(storage, key, defaultValue) {
  const [state, setState] = react_1.useState(() => {
    const storedState = getItem(storage, key);
    return storedState !== null ? storedState : defaultValue;
  });
  const checkStorageRef = react_1.useRef(true);
  react_1.useEffect(() => {
    // Check for an existing value on the initial render...
    if (checkStorageRef.current) {
      checkStorageRef.current = false;
      const storedState = getItem(storage, key);
      if (storedState !== null) setState(storedState);
    }
  }, [storage, key]);
  react_1.useEffect(() => {
    setItem(storage, key, state);
  }, [storage, key, state]);
  return [state, setState];
}
/**
 * A convenient wrapper for useStorage(window.localStorage, ...)
 */
exports.default = useStorage;
function useLocalStorage(key, defaultValue) {
  return useStorage(getStorage('localStorage'), key, defaultValue);
}
/**
 * A convenient wrapper for useStorage(window.sessionStorage, ...)
 */
exports.useLocalStorage = useLocalStorage;
function useSessionStorage(key, defaultValue) {
  return useStorage(getStorage('sessionStorage'), key, defaultValue);
}
exports.useSessionStorage = useSessionStorage;
